export const Swoosh = ({ className = "" }) => (
  <svg viewBox="0 0 120 60" fill="none" className={className} aria-hidden="true">
    <path
      d="M4 44C22 40 44 30 78 14c8-4 16-8 34-10-10 8-22 14-40 22M30 40l40-14"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path d="M64 20l14 10-20 6z" fill="currentColor" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-semibold tracking-tight leading-none ${className}`}>
    AERO DETAIL <span className="text-purple">LAB</span>
  </span>
);
